export const FeaturedArray=[
    {
      id:1,
      img:"https://i5.walmartimages.com/dfw/4ff9c6c9-92f4/k2-_e95a21dd-f7c2-4919-aa58-afe1a5d9df2a.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"Apple",
      tag:"apple"
    },
    {
      id:2,
      img:"https://i5.walmartimages.com/dfw/4ff9c6c9-da69/k2-_7e544b5a-d798-4573-b347-059ff9b737eb.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"Samsung",
      tag:"samsung"
    },
    {
      id:3,
      img:"https://i5.walmartimages.com/dfw/4ff9c6c9-d38f/k2-_01c85fe8-b2f6-460c-b8c1-3d565926eeab.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"Sonos",
      tag:"sonos"
    },
    {
      id:4,
      img:"https://i5.walmartimages.com/dfw/4ff9c6c9-91ee/k2-_0a4a893a-19fc-496f-96be-4577943c392a.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"Bose",
      tag:"bose"
    },
    {
      id:5,
      img:"https://i5.walmartimages.com/dfw/4ff9c6c9-b941/k2-_245eea3e-831f-461a-8479-a8af81d26084.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"HP",
      tag:"hp"
    },
    {
      id:6,
      img:"https://i5.walmartimages.com/dfw/4ff9c6c9-47a3/k2-_a86144ce-944e-43da-abad-57401d14520c.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"Canon",
      tag:"canon"
    },
    {
      id:7,
      img:"https://i5.walmartimages.com/dfw/4ff9c6c9-ecdf/k2-_a0d564b3-5c46-476b-8519-a1b0e86f3ae2.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"LG",
      tag:"lg"
    },
    {
      id:8,
    img:"https://i5.walmartimages.com/dfw/4ff9c6c9-9550/k2-_bbf14d0c-bc08-41e1-9394-2aa307390086.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"GoPro",
      tag:"gopro"
    },
      {
      id:9,
    img:"https://i5.walmartimages.com/dfw/4ff9c6c9-ce8b/k2-_e6f5b34c-75d8-4aa1-886e-6eb4a5d6bb7e.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"Sony",
      tag:"sony"
    },
      {
      id:10,
    img:"https://i5.walmartimages.com/dfw/4ff9c6c9-a927/k2-_d44011cb-10e6-4daa-95f7-b0fdb753a52f.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"Roku",
      tag:"roku"
    },
      {
      id:11,
    img:"https://i5.walmartimages.com/dfw/4ff9c6c9-6b78/k2-_91ee3b8b-3c72-47f7-a521-c24aa02bc6f3.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"Onn.",
      tag:"onn"
    },
      {
      id:12,
    img:"https://i5.walmartimages.com/dfw/4ff9c6c9-8da5/k2-_b834908a-5995-4686-b3a5-ef88d2dbd033.v1.jpg?odnHeight=290&odnWidth=290&odnBg=FFFFFF",
      name:"ASUS",
      tag:"asus"
    }
  ];
  export const getTokenFromLocalStorage = localStorage.getItem("customer")
  ? JSON.parse(localStorage.getItem("customer"))
  : null;

  export const usaStates = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
  "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
  "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
  "Wisconsin", "Wyoming"
];
export const publishKey="pk_test_51RVPypQEPdrOufmhygwXwB4o3PtFivSJnwkcOBmNFes0XgytqxcnRjfT2a0KhcpJNbVc3JE7TxIHEswFcr5KmhY100S6TfEX2f"
export const symbole="₹"
export const countries = [
  { value: "AFGHANISTAN", label: "Afghanistan" },
  { value: "ALBANIA", label: "Albania" },
  { value: "ALGERIA", label: "Algeria" },
  { value: "ANDORRA", label: "Andorra" },
  { value: "ANGOLA", label: "Angola" },
  { value: "ANTIGUA_AND_BARBUDA", label: "Antigua and Barbuda" },
  { value: "ARGENTINA", label: "Argentina" },
  { value: "ARMENIA", label: "Armenia" },
  { value: "AUSTRALIA", label: "Australia" },
  { value: "AUSTRIA", label: "Austria" },
  { value: "AZERBAIJAN", label: "Azerbaijan" },
  { value: "BAHAMAS", label: "Bahamas" },
  { value: "BAHRAIN", label: "Bahrain" },
  { value: "BANGLADESH", label: "Bangladesh" },
  { value: "BARBADOS", label: "Barbados" },
  { value: "BELARUS", label: "Belarus" },
  { value: "BELGIUM", label: "Belgium" },
  { value: "BELIZE", label: "Belize" },
  { value: "BENIN", label: "Benin" },
  { value: "BHUTAN", label: "Bhutan" },
  { value: "BOLIVIA", label: "Bolivia" },
  { value: "BOSNIA_AND_HERZEGOVINA", label: "Bosnia and Herzegovina" },
  { value: "BOTSWANA", label: "Botswana" },
  { value: "BRAZIL", label: "Brazil" },
  { value: "BRUNEI", label: "Brunei" },
  { value: "BULGARIA", label: "Bulgaria" },
  { value: "BURKINA_FASO", label: "Burkina Faso" },
  { value: "BURUNDI", label: "Burundi" },
  { value: "CABO_VERDE", label: "Cabo Verde" },
  { value: "CAMBODIA", label: "Cambodia" },
  { value: "CAMEROON", label: "Cameroon" },
  { value: "CANADA", label: "Canada" },
  { value: "CENTRAL_AFRICAN_REPUBLIC", label: "Central African Republic" },
  { value: "CHAD", label: "Chad" },
  { value: "CHILE", label: "Chile" },
  { value: "CHINA", label: "China" },
  { value: "COLOMBIA", label: "Colombia" },
  { value: "COMOROS", label: "Comoros" },
  { value: "CONGO_BRAZZAVILLE", label: "Congo - Brazzaville" },
  { value: "CONGO_KINSHASA", label: "Congo - Kinshasa" },
  { value: "COSTA_RICA", label: "Costa Rica" },
  { value: "COTE_DIVOIRE", label: "Côte d’Ivoire" },
  { value: "CROATIA", label: "Croatia" },
  { value: "CUBA", label: "Cuba" },
  { value: "CYPRUS", label: "Cyprus" },
  { value: "CZECHIA", label: "Czechia" },
  { value: "DENMARK", label: "Denmark" },
  { value: "DJIBOUTI", label: "Djibouti" },
  { value: "DOMINICA", label: "Dominica" },
  { value: "DOMINICAN_REPUBLIC", label: "Dominican Republic" },
  { value: "ECUADOR", label: "Ecuador" },
  { value: "EGYPT", label: "Egypt" },
  { value: "EL_SALVADOR", label: "El Salvador" },
  { value: "EQUATORIAL_GUINEA", label: "Equatorial Guinea" },
  { value: "ERITREA", label: "Eritrea" },
  { value: "ESTONIA", label: "Estonia" },
  { value: "ESWATINI", label: "Eswatini" },
  { value: "ETHIOPIA", label: "Ethiopia" },
  { value: "FIJI", label: "Fiji" },
  { value: "FINLAND", label: "Finland" },
  { value: "FRANCE", label: "France" },
  { value: "GABON", label: "Gabon" },
  { value: "GAMBIA", label: "Gambia" },
  { value: "GEORGIA", label: "Georgia" },
  { value: "GERMANY", label: "Germany" },
  { value: "GHANA", label: "Ghana" },
  { value: "GREECE", label: "Greece" },
  { value: "GRENADA", label: "Grenada" },
  { value: "GUATEMALA", label: "Guatemala" },
  { value: "GUINEA", label: "Guinea" },
  { value: "GUINEA_BISSAU", label: "Guinea-Bissau" },
  { value: "GUYANA", label: "Guyana" },
  { value: "HAITI", label: "Haiti" },
  { value: "HONDURAS", label: "Honduras" },
  { value: "HUNGARY", label: "Hungary" },
  { value: "ICELAND", label: "Iceland" },
  { value: "INDIA", label: "India" },
  { value: "INDONESIA", label: "Indonesia" },
  { value: "IRAN", label: "Iran" },
  { value: "IRAQ", label: "Iraq" },
  { value: "IRELAND", label: "Ireland" },
  { value: "ISRAEL", label: "Israel" },
  { value: "ITALY", label: "Italy" },
  { value: "JAMAICA", label: "Jamaica" },
  { value: "JAPAN", label: "Japan" },
  { value: "JORDAN", label: "Jordan" },
  { value: "KAZAKHSTAN", label: "Kazakhstan" },
  { value: "KENYA", label: "Kenya" },
  { value: "KIRIBATI", label: "Kiribati" },
  { value: "KOSOVO", label: "Kosovo" },
  { value: "KUWAIT", label: "Kuwait" },
  { value: "KYRGYZSTAN", label: "Kyrgyzstan" },
  { value: "LAOS", label: "Laos" },
  { value: "LATVIA", label: "Latvia" },
  { value: "LEBANON", label: "Lebanon" },
  { value: "LESOTHO", label: "Lesotho" },
  { value: "LIBERIA", label: "Liberia" },
  { value: "LIBYA", label: "Libya" },
  { value: "LIECHTENSTEIN", label: "Liechtenstein" },
  { value: "LITHUANIA", label: "Lithuania" },
  { value: "LUXEMBOURG", label: "Luxembourg" },
  { value: "MADAGASCAR", label: "Madagascar" },
  { value: "MALAWI", label: "Malawi" },
  { value: "MALAYSIA", label: "Malaysia" },
  { value: "MALDIVES", label: "Maldives" },
  { value: "MALI", label: "Mali" },
  { value: "MALTA", label: "Malta" },
  { value: "MARSHALL_ISLANDS", label: "Marshall Islands" },
  { value: "MAURITANIA", label: "Mauritania" },
  { value: "MAURITIUS", label: "Mauritius" },
  { value: "MEXICO", label: "Mexico" },
  { value: "MICRONESIA", label: "Micronesia" },
  { value: "MOLDOVA", label: "Moldova" },
  { value: "MONACO", label: "Monaco" },
  { value: "MONGOLIA", label: "Mongolia" },
  { value: "MONTENEGRO", label: "Montenegro" },
  { value: "MOROCCO", label: "Morocco" },
  { value: "MOZAMBIQUE", label: "Mozambique" },
  { value: "MYANMAR", label: "Myanmar" },
  { value: "NAMIBIA", label: "Namibia" },
  { value: "NAURU", label: "Nauru" },
  { value: "NEPAL", label: "Nepal" },
  { value: "NETHERLANDS", label: "Netherlands" },
  { value: "NEW_ZEALAND", label: "New Zealand" },
  { value: "NICARAGUA", label: "Nicaragua" },
  { value: "NIGER", label: "Niger" },
  { value: "NIGERIA", label: "Nigeria" },
  { value: "NORTH_KOREA", label: "North Korea" },
  { value: "NORTH_MACEDONIA", label: "North Macedonia" },
  { value: "NORWAY", label: "Norway" },
  { value: "OMAN", label: "Oman" },
  { value: "PAKISTAN", label: "Pakistan" },
  { value: "PALAU", label: "Palau" },
  { value: "PALESTINE", label: "Palestine" },
  { value: "PANAMA", label: "Panama" },
  { value: "PAPUA_NEW_GUINEA", label: "Papua New Guinea" },
  { value: "PARAGUAY", label: "Paraguay" },
  { value: "PERU", label: "Peru" },
  { value: "PHILIPPINES", label: "Philippines" },
  { value: "POLAND", label: "Poland" },
  { value: "PORTUGAL", label: "Portugal" },
  { value: "QATAR", label: "Qatar" },
  { value: "ROMANIA", label: "Romania" },
  { value: "RUSSIA", label: "Russia" },
  { value: "RWANDA", label: "Rwanda" },
  { value: "SAINT_KITTS_AND_NEVIS", label: "Saint Kitts and Nevis" },
  { value: "SAINT_LUCIA", label: "Saint Lucia" },
  { value: "SAINT_VINCENT_AND_THE_GRENADINES", label: "Saint Vincent and the Grenadines" },
  { value: "SAMOA", label: "Samoa" },
  { value: "SAN_MARINO", label: "San Marino" },
  { value: "SAO_TOME_AND_PRINCIPE", label: "São Tomé and Príncipe" },
  { value: "SAUDI_ARABIA", label: "Saudi Arabia" },
  { value: "SENEGAL", label: "Senegal" },
  { value: "SERBIA", label: "Serbia" },
  { value: "SEYCHELLES", label: "Seychelles" },
  { value: "SIERRA_LEONE", label: "Sierra Leone" },
  { value: "SINGAPORE", label: "Singapore" },
  { value: "SLOVAKIA", label: "Slovakia" },
  { value: "SLOVENIA", label: "Slovenia" },
  { value: "SOLOMON_ISLANDS", label: "Solomon Islands" },
  { value: "SOMALIA", label: "Somalia" },
  { value: "SOUTH_AFRICA", label: "South Africa" },
  { value: "SOUTH_KOREA", label: "South Korea" },
  { value: "SOUTH_SUDAN", label: "South Sudan" },
  { value: "SPAIN", label: "Spain" },
  { value: "SRI_LANKA", label: "Sri Lanka" },
  { value: "SUDAN", label: "Sudan" },
  { value: "SURINAME", label: "Suriname" },
  { value: "SWEDEN", label: "Sweden" },
  { value: "SWITZERLAND", label: "Switzerland" },
  { value: "SYRIA", label: "Syria" },
  { value: "TAJIKISTAN", label: "Tajikistan" },
  { value: "TANZANIA", label: "Tanzania" },
  { value: "THAILAND", label: "Thailand" },
  { value: "TIMOR_LESTE", label: "Timor-Leste" },
  { value: "TOGO", label: "Togo" },
  { value: "TONGA", label: "Tonga" },
  { value: "TRINIDAD_AND_TOBAGO", label: "Trinidad and Tobago" },
  { value: "TUNISIA", label: "Tunisia" },
  { value: "TURKEY", label: "Turkey" },
  { value: "TURKMENISTAN", label: "Turkmenistan" },
  { value: "TUVALU", label: "Tuvalu" },
  { value: "UGANDA", label: "Uganda" },
  { value: "UKRAINE", label: "Ukraine" },
  { value: "UNITED_ARAB_EMIRATES", label: "United Arab Emirates" },
  { value: "UNITED_KINGDOM", label: "United Kingdom" },
  { value: "UNITED_STATES", label: "United States" },
  { value: "URUGUAY", label: "Uruguay" },
  { value: "UZBEKISTAN", label: "Uzbekistan" },
  { value: "VANUATU", label: "Vanuatu" },
  { value: "VATICAN_CITY", label: "Vatican City" },
  { value: "VENEZUELA", label: "Venezuela" },
  { value: "VIETNAM", label: "Vietnam" },
  { value: "YEMEN", label: "Yemen" },
  { value: "ZAMBIA", label: "Zambia" },
  { value: "ZIMBABWE", label: "Zimbabwe" }
];
